import { cn } from '../lib/utils'

export type AdminTab = 'overview' | 'transactions' | 'users' | 'health' | 'analytics' | 'teams' | 'predictions' | 'nl-query' | 'anomalies' | 'multi-chain' | 'whale-flows' | 'compliance' | 'intelligence' | 'protocols' | 'liquidity' | 'agentic-approvals'
export type UserTab = 'overview' | 'protection' | 'wallet' | 'rewards' | 'history' | 'notifications' | 'settings' | 'leaderboard' | 'carbon-report' | 'address-check' | 'insurance'
export type BuilderTab = 'overview' | 'blocks' | 'queue' | 'performance' | 'bridge-protection'
export type TraderTab = 'overview' | 'trade' | 'portfolio' | 'market' | 'whale-flows' | 'liquidation' | 'address-check' | 'protocols' | 'liquidity'
export type RoleView = 'Admin' | 'User' | 'Builder' | 'Trader'

interface Tab { key: string; label: string }

const ROLE_TABS: Record<RoleView, Tab[]> = {
  Admin: [
    { key: 'overview',     label: 'Overview' },
    { key: 'transactions', label: 'Transactions' },
    { key: 'users',        label: 'Users' },
    { key: 'health',       label: 'System Health' },
    { key: 'analytics',    label: 'Analytics' },
    { key: 'teams',        label: 'Teams' },
    { key: 'predictions',  label: 'AI Predictions' },
    { key: 'nl-query',     label: 'NL Query' },
    { key: 'anomalies',    label: 'Anomalies' },
    { key: 'multi-chain',  label: 'Multi-Chain' },
    { key: 'whale-flows',  label: 'Whale Flows' },
    { key: 'compliance',   label: 'Compliance' },
    { key: 'intelligence', label: 'Intelligence' },
    { key: 'protocols',    label: 'Protocols' },
    { key: 'liquidity',    label: 'Liquidity' },
    { key: 'agentic-approvals', label: 'Approvals' },
  ],
  User: [
    { key: 'overview',       label: 'Overview' },
    { key: 'protection',     label: 'Protection' },
    { key: 'address-check',  label: 'Address Check' },
    { key: 'insurance',      label: 'Insurance' },
    { key: 'wallet',         label: 'Wallet' },
    { key: 'rewards',        label: 'Rewards' },
    { key: 'history',        label: 'History' },
    { key: 'notifications',  label: 'Notifications' },
    { key: 'settings',       label: 'Settings' },
    { key: 'leaderboard',    label: 'Leaderboard' },
    { key: 'carbon-report',  label: 'Carbon Report' },
  ],
  Builder: [
    { key: 'overview',          label: 'Overview' },
    { key: 'blocks',            label: 'Blocks' },
    { key: 'queue',             label: 'MEV Queue' },
    { key: 'performance',       label: 'Performance' },
    { key: 'bridge-protection', label: 'Bridge Protection' },
  ],
  Trader: [
    { key: 'overview',      label: 'Overview' },
    { key: 'trade',         label: 'Trade' },
    { key: 'portfolio',     label: 'Portfolio' },
    { key: 'market',        label: 'Market' },
    { key: 'whale-flows',   label: 'Whale Flows' },
    { key: 'liquidation',   label: 'Liquidation Risk' },
    { key: 'address-check', label: 'Address Check' },
    { key: 'protocols',     label: 'Protocols' },
    { key: 'liquidity',     label: 'Liquidity' },
  ],
}

interface DashboardTabBarProps {
  roleView: RoleView
  activeTab: string
  onTabChange: (tab: string) => void
}

export function DashboardTabBar({ roleView, activeTab, onTabChange }: DashboardTabBarProps) {
  const tabs = ROLE_TABS[roleView]

  return (
    <div className="sticky top-16 z-40 backdrop-blur-md bg-surface-base/80 border-b border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center gap-1 py-2">
          {tabs.map(tab => (
            <button
              key={tab.key}
              onClick={() => onTabChange(tab.key)}
              className={cn(
                'px-5 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap',
                activeTab === tab.key
                  ? 'bg-gradient-to-r from-primary to-accent text-white shadow-glow-sky'
                  : 'text-white/50 hover:text-white hover:bg-white/[0.06]'
              )}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

export { ROLE_TABS }
